"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseLoadStreamJob = void 0;

var _hls = _interopRequireDefault(require("hls.js"));

var _Queue = require("../Queue");

var _LoadingMode = require("../LoadingMode");

var _shared = require("../shared");

var _getProperty = require("../../../../util/getProperty");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var defaultOptions = {
  startAt: -1,
  level: _LoadingMode.LoadingMode.MED,
  mainSources: [],
  autoPlay: true,
  maxExecutionTime: 30000,
  muted: true,
  autoPause: false
};

var BaseLoadStreamJob = /*#__PURE__*/function (_QueueItem) {
  _inherits(BaseLoadStreamJob, _QueueItem);

  var _super = _createSuper(BaseLoadStreamJob);

  function BaseLoadStreamJob(source, hlsUrl) {
    var _this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, BaseLoadStreamJob);

    _this = _super.call(this);

    var opts = _objectSpread(_objectSpread({}, defaultOptions), options); // instance setup


    _this._name = "BaseLoadStreamJob";
    _this.timeout = null;
    _this.resolve = null;
    _this.sourceHLS = null;
    _this.onCanPlay = _this.onCanPlay.bind(_assertThisInitialized(_this));
    _this.onMetaDataLoaded = _this.onMetaDataLoaded.bind(_assertThisInitialized(_this));
    _this.canPlayCheck = _this.canPlayCheck.bind(_assertThisInitialized(_this)); // primary properties

    _this.source = source;
    _this.hlsUrl = hlsUrl; // properties from options

    _this.startAt = opts.startAt;

    if (opts.startAtUTC > 0) {
      _this.startAt = (0, _shared.utcToVideoTime)(opts.startAtUTC, source.moment);

      _this.log("startAt from utc", _this.startAt);

      _this.log("startAtUTC", opts.startAtUTC);
    }

    _this.mainSources = opts.mainSources;
    _this.level = opts.level;
    _this.autoPlay = opts.autoPlay;
    _this.maxExecutionTime = opts.maxExecutionTime;
    _this.canPlayTimeout = null;
    _this.muted = opts.muted;
    _this.autoPause = opts.autoPause;
    return _this;
  }

  _createClass(BaseLoadStreamJob, [{
    key: "beforeRun",
    value: function () {
      var _beforeRun = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function beforeRun() {
        return _beforeRun.apply(this, arguments);
      }

      return beforeRun;
    }()
  }, {
    key: "afterRun",
    value: function () {
      var _afterRun = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", true);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function afterRun() {
        return _afterRun.apply(this, arguments);
      }

      return afterRun;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var success;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.beforeRun();

              case 2:
                _context3.next = 4;
                return this.load();

              case 4:
                success = _context3.sent;
                _context3.next = 7;
                return this.afterRun();

              case 7:
                return _context3.abrupt("return", true);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function run() {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }, {
    key: "endJob",
    value: function endJob(val) {
      this.cleanup();

      if (this.resolve) {
        this.resolve(val);
        this.resolve = null;
      }
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      if (this.source && this.source.video) {
        this.source.video.removeEventListener("canplay", this.onCanPlay);
        this.source.video.removeEventListener("loadedmetadata", this.onMetaDataLoaded);
      }

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      if (this.canPlayTimeout) {
        clearTimeout(this.canPlayTimeout);
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      _get(_getPrototypeOf(BaseLoadStreamJob.prototype), "cancel", this).call(this);

      if (this.resolve) {
        this.resolve(false);
        this.resolve = null;
      }
    }
  }, {
    key: "beforeOnCanPlay",
    value: function beforeOnCanPlay() {// subclasses can implement if needed
    }
  }, {
    key: "afterOnCanPlay",
    value: function afterOnCanPlay() {// subclasses can implement if needed
    }
  }, {
    key: "onCanPlay",
    value: function onCanPlay() {
      var _this2 = this;

      this.beforeOnCanPlay();
      this.source.video.muted = this.muted;
      this.log("muted", this.source.video.id, this.muted);

      if (this.autoPlay) {
        var p = this.source.video.play();

        if (p instanceof Promise) {
          p.then(function (res) {
            _this2.afterOnCanPlay();

            _this2.endJob(true);
          }).catch(function (e) {
            console.error(_this2._id, _this2._name, ".onCanPlay chatch", e);

            _this2.afterOnCanPlay();

            _this2.endJob(true);
          });
        } else {
          this.afterOnCanPlay();
          this.endJob(true);
        }
      } else {
        if (this.autoPause) {
          this.source.video.pause();
        }

        this.afterOnCanPlay();
        this.endJob(true);
      }
    }
  }, {
    key: "canPlayCheck",
    value: function canPlayCheck() {
      clearTimeout(this.canPlayTimeout);
      this.canPlayTimeout = null;

      if (this.source.video.duration === this.source.video.duration) {
        this.onCanPlay();
      } else {
        this.canPlayTimeout = setTimeout(this.canPlayCheck, 250);
      }
    }
  }, {
    key: "onMetaDataLoaded",
    value: function onMetaDataLoaded(e) {
      if (this.startAt >= 0) {
        this.source.video.currentTime = this.startAt;
      }
    }
  }, {
    key: "beforeLoad",
    value: function beforeLoad() {
      // subclasses can implement if needed
      return true;
    }
  }, {
    key: "afterLoad",
    value: function afterLoad() {
      // subclasses can implement if needed
      return true;
    }
  }, {
    key: "getHLSConfig",
    value: function getHLSConfig() {
      return {
        autoStart: false,
        autoLoad: true,
        capLevelToPlayerSize: true
      };
    }
  }, {
    key: "onHLSManifestParsed",
    value: function onHLSManifestParsed(e, data) {// subclasses can implement if needed
    }
  }, {
    key: "afterHLSCreated",
    value: function afterHLSCreated(hls) {// subclasses can implement if needed
    }
  }, {
    key: "load",
    value: function load() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.resolve = resolve; // make sure the job timesout

        _this3.timeout = setTimeout(function () {
          _this3.endJob(true);
        }, _this3.maxExecutionTime);

        if (!_this3.beforeLoad()) {
          return;
        }

        if (!_this3.source || !_this3.source.moment) {
          // no moment for source abort
          _this3.endJob(true);

          return;
        }

        _this3.source.video.addEventListener("canplay", _this3.onCanPlay);

        _this3.source.video.addEventListener("loadedmetadata", _this3.onMetaDataLoaded);

        var dynamicVideoUrl = (0, _getProperty.getProperty)("moment.dynamic_video_url", _this3.source, null);

        if (dynamicVideoUrl) {
          // non hls videos
          _this3.source.video.src = dynamicVideoUrl;
          _this3.source.hls = "NATIVE"; // should work same as native hls player

          _this3.sourceHLS = "NATIVE"; // should works same as native hls player

          _this3.source.video.load();
        } else if (_hls.default.isSupported()) {
          var config = _this3.getHLSConfig();

          var hls = new _hls.default(config);

          _this3.afterHLSCreated(hls);

          hls.loadSource(_this3.hlsUrl);
          hls.attachMedia(_this3.source.video);
          _this3.source.hls = hls;
          _this3.sourceHLS = hls;
          hls.on(_hls.default.Events.MANIFEST_PARSED, function (e, data) {
            _this3.onHLSManifestParsed(e, data);
          });
        } else {
          _this3.source.video.setAttribute("src", _this3.hlsUrl);

          _this3.source.hls = "NATIVE";
          _this3.sourceHLS = "NATIVE";

          _this3.source.video.load();
        }

        _this3.canPlayTimeout = setTimeout(_this3.canPlayCheck(), 1500);
      });
    }
  }]);

  return BaseLoadStreamJob;
}(_Queue.QueueItem);

exports.BaseLoadStreamJob = BaseLoadStreamJob;